var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 0C4.74306 0 2.5 2.24306 2.5 5.00001C2.5 5.82765 2.70692 6.64825 3.10029 7.3761L7.22658 14.8389C7.28151 14.9384 7.38619 15 7.50001 15C7.61383 15 7.71851 14.9384 7.77344 14.8389L11.9012 7.37364C12.2931 6.64825 12.5 5.82762 12.5 4.99998C12.5 2.24306 10.257 0 7.50001 0ZM7.50001 7.5C6.12153 7.5 5.00002 6.37849 5.00002 5.00001C5.00002 3.62153 6.12153 2.50002 7.50001 2.50002C8.87849 2.50002 10 3.62153 10 5.00001C10 6.37849 8.87849 7.5 7.50001 7.5Z",
    fill: "#BC863D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.674d7a71f8f15cb13a4c89d88b76385e.svg";
export { ForwardRef as ReactComponent };